import React, { useState } from 'react';

interface IntroVideoProps {
  videoUrl: string;
  overlayText?: string;
  maxWidth?: string;
  onVideoStart?: () => void;
  autoShow?: boolean;
  thumbnailUrl?: string;
}

const IntroVideo: React.FC<IntroVideoProps> = ({
  videoUrl,
  overlayText = 'Play 2-min video',
  maxWidth = '700px',
  onVideoStart,
  autoShow = false,
  thumbnailUrl,
}) => {
  const [showVideo, setShowVideo] = useState(autoShow);

  const handleVideoClick = () => {
    setShowVideo(true);
    onVideoStart?.();
  };

  return (
    <div style={{ maxWidth: maxWidth, margin: '0 auto' }}>
      <div
        style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden',
          background: thumbnailUrl ? `url(${thumbnailUrl}) center/cover` : '#f5f5f5',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        }}
      >
        {showVideo ? (
          <iframe
            src={videoUrl}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '12px',
              border: 'none',
            }}
            allowFullScreen
            allow="autoplay; fullscreen"
            title="Timely Video"
          />
        ) : (
          <div
            onClick={handleVideoClick}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
              borderRadius: '12px',
              background: 'rgba(0, 0, 0, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                padding: '16px 32px',
                borderRadius: '50px',
                background: '#B171FF',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '20px',
                fontWeight: 600,
                color: 'white',
                transition: 'transform 0.2s ease, background 0.2s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.background = '#C68AFF';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.background = '#B171FF';
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3 2L13 8L3 14V2Z" fill="white" />
              </svg>
              {overlayText}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IntroVideo;
